import React from "react";
import Prose from "../utility/prose";
import { SurveyFormProvider } from "../../context/SurveyFormContext"
import SurveyForm from "../form/survey/Form"


const ParksForm = () => {

    return (
        <Prose>
          <div className="w-full max-w-[550px] mx-auto px-4">
            <SurveyFormProvider>
              <SurveyForm />
            </SurveyFormProvider>
          </div>
        </Prose>
    )
}

export default ParksForm
